export default function globalModal() {
	const ensureModal = () => {
		let dlg = document.querySelector('dialog[data-global-modal]');
		if (dlg) {
			return dlg;
		}

		const tpl = document.createElement('div');
		tpl.innerHTML = `
        <dialog class="farlo-ui-modal" data-global-modal aria-labelledby="global-modal-title">
            <div class="farlo-ui-modal__backdrop" data-global-modal-close></div>
            <form method="dialog" class="farlo-ui-modal__card" role="document">
            	<button type="submit" class="farlo-ui-modal__close" aria-label="Close" data-global-modal-close>×</button>
				<div class="farlo-ui-modal__card-content">
					<header class="farlo-ui-modal__header" data-global-modal-header hidden>
					<h3 id="global-modal-title" data-global-modal-title></h3>
					</header>
					<div class="farlo-ui-modal__body" data-global-modal-body></div>
				</div>
            </form>
        </dialog>
        `;
		dlg = tpl.firstElementChild;
		document.body.appendChild(dlg);

		dlg.addEventListener('click', (e) => {
			if (e.target.matches('[data-global-modal-close]')) {
				dlg.close();
			}
		});
		return dlg;
	};

	const openWith = (btn) => {
		const dlg = ensureModal();
		const body = dlg.querySelector('[data-global-modal-body]');
		const head = dlg.querySelector('[data-global-modal-header]');
		const titleEl = dlg.querySelector('[data-global-modal-title]');

		let html = btn.getAttribute('data-modal-html') || '';
		const targetSel = btn.getAttribute('data-modal-target');
		if (!html && targetSel) {
			const src = document.querySelector(targetSel);
			if (src) {
				html = src.innerHTML;
			}
		}

		const ttl = btn.getAttribute('data-modal-title') || btn.getAttribute('aria-label') || '';
		if (ttl) {
			titleEl.textContent = ttl;
			head.hidden = false;
		} else {
			titleEl.textContent = '';
			head.hidden = true;
		}

		const w = btn.getAttribute('data-modal-width');
		const card = dlg.querySelector('.farlo-ui-modal__card');
		if (w) {
			card.style.maxWidth = /^\d+$/.test(w) ? `${ w }px` : w;
		} else {
			card.style.removeProperty('max-width');
		}

		body.innerHTML = html || '<p>No content.</p>';
		if (dlg.showModal) {
			dlg.showModal();
		} else {
			dlg.setAttribute('open', '');
		}
	};

	document.addEventListener('click', (e) => {
		const trigger = e.target.closest('[data-modal-html],[data-modal-target]');
		if (!trigger) {
			return;
		}
		e.preventDefault();
		openWith(trigger);
	});
}
